import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative z-10 bg-[#0f172a] text-gray-400 py-4 px-6 text-center text-sm border-t border-white/5">
      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 flex-wrap">
        <span>© 2026 RitmoIQ</span>
        <span className="hidden sm:inline text-gray-600">|</span>
        <Link 
          to="/privacy" 
          className="text-blue-400 hover:text-blue-300 hover:underline transition"
        >
          מדיניות פרטיות
        </Link>
        <span className="hidden sm:inline text-gray-600">|</span>
        <Link 
          to="/privacy-en" 
          className="text-blue-400 hover:text-blue-300 hover:underline transition"
        >
          Privacy Policy
        </Link>
        <span className="hidden sm:inline text-gray-600">|</span>
        <Link 
          to="/terms" 
          className="text-blue-400 hover:text-blue-300 hover:underline transition"
        >
          Terms of Service
        </Link>
        <span className="hidden sm:inline text-gray-600">|</span>
        <a 
          href="mailto:support@ritmoiq.com"
          className="text-blue-400 hover:text-blue-300 hover:underline transition"
        >
          צור קשר
        </a>
      </div>
    </footer>
  );
};

export default Footer;
